'use client';

import { GetWrapupType, WrapupModuleCombatData } from "@/src/server/models/seasonal/wrapup/modules/getwrapup";
import IWrapupModule from "./imodule";
import WrapupModuleCombatComponent from "./combatcomponent";

export default class WrapupModuleCombat implements IWrapupModule {
    constructor() { }

    get id(): string { return 'combat'; }
    get name(): string { return 'Combat'; }

    canRender(wrapupData: GetWrapupType): boolean {
        const data = wrapupData.data?.combat as WrapupModuleCombatData;
        return data != null;
    }

    getComponentClass() {
        return WrapupModuleCombatComponent;
    }
}
